import { initializeSharing } from "app/scripts/sharing"
import { logCustomDatadogAction, sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import { ConnectPage } from "app/scripts/connect_page"
import TqaListTabs from "app/scripts/tqa_list_tabs"

import "stylesheets/connect.scss"

sharedVanillaSetup()

document.addEventListener(
  "DOMContentLoaded",
  function () {
    logCustomDatadogAction?.("connect_service_xy_page_viewed")
    initializeSharing()
    ConnectPage()
    TqaListTabs()
  },
  { once: true }
)
